import BaseRepository from '@/api/repositories/BaseRepository';

export default class DocumentDefinitionRepository extends BaseRepository {
	getAll() {
		return this.get('documentDefinitions', {});
	}

	getByKey(key, source) {
		return this.get(`documentDefinitions/${key}`, {
			source,
		});
	}

	getElements() {
		return this.get('documentDefinitions/elements', {});
	}

	update(key, data, source) {
		return this.put(
			`documentDefinitions/${key}`,
			{
				source,
			},
			data,
		);
	}

	updateOverrideStatus(key, isActive) {
		return this.put(
			`documentDefinitions/${key}/override/status`,
			{},
			{
				is_active: isActive,
			},
		);
	}

	preview(data) {
		return this.post('documentDefinitions/preview', {}, data);
	}
}
